<template>
	<div class="">
		<base-page-heading
			title="Currencies"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="currencyShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<CurrencyTable
				@routeCurrency="routeCurrency"
			/>
		</div>
	</div>
</template>
